<template>
    <v-card>
        <v-card-title>Alarm Manual Entry</v-card-title>

        <v-card-text>
            <v-form ref="manualEntryForm" v-model="manualEntryFormValid" :lazy-validation="true">
                <v-row dense >

                <v-col cols="12">
                    <span>Please remember that when entering an alarm manually, all of the normal rules regarding disregarding, shakeout times, etc. still apply.</span>
                </v-col>

                <v-col cols="12" md="6">
                    <v-datetime-picker label="Date/Time" v-model="datetime" :timeFormat="'HH:mm:ss'" :datePickerProps="dpProps" :timePickerProps="tpProps"></v-datetime-picker>
                </v-col>
                <v-col cols="12" md="6">
                    <v-text-field label="Office" v-model="office" color="#c42111"></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                    <v-text-field label="Location" v-model="location" color="#c42111"></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                    <v-select label="Severity" v-model="severity" :items="severityList" color="#c42111"></v-select>
                </v-col>
                <v-col cols="12">
                    <v-text-field label="Description" v-model="description" color="#c42111"></v-text-field>
                </v-col>

                </v-row>
            </v-form>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn text @click="createAlarm">Create</v-btn>
            <v-btn text @click="$emit('cancel')">Cancel</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
export default {
    name: 'AlarmManualEntry',
    props: [],
    components: {

    },
    data: () => ({
        manualEntryFormValid: true,
        datetime: null,
        office: '',
        location: '',
        severity: 'CRITICAL',
        severityList: ['CRITICAL', 'MAJOR', 'MINOR', 'OBSERVATIONAL'],
        description: '',
        tpProps: {
            useSeconds: true,
            format: '24hr',
            color: '#c42111'
        },
        dpProps: {
            color: '#c42111'
        },
    }),

    computed: {
    },

    methods: {
        createAlarm: function() {
            let alarm = {
                datetime: TELSA.moment(this.datetime).format('YYYY-MM-DD HH:mm:ss'),
                office: this.office,
                location: this.location,
                severity: this.severity,
                description: this.description
            };
            this.$emit('create', alarm);
        }
    },

    mounted() {
        this.datetime = TELSA.moment.tz(this.$store.state.batchConfig.timezone).format('YYYY-MM-DD HH:mm:ss');
    }

  
};
</script>
